export const SET_BRANDED_EMAIL_TEMPLATE_OPTIONS_FOR_AUTH = 'SET_BRANDED_EMAIL_TEMPLATE_OPTIONS_FOR_AUTH';
